// extracted by mini-css-extract-plugin
export var actionIcon = "_qw-0";